export default "<app-navbar [api_url]=\"apiUrl\"></app-navbar>\r\n<router-outlet></router-outlet>\r\n<app-footer [api_url]=\"apiUrl\"></app-footer>"